export const deviceDetailKey = {
  all: ['devices', 'detail'] as const,
  profile: (id: string) => [...deviceDetailKey.all, 'profile', id] as const,
  profileHeader: (id: string) =>
    [...deviceDetailKey.all, 'profileHeader', id] as const,
  history: (id: string) => [...deviceDetailKey.all, 'history', id] as const,
  mdm: (id: string) => [...deviceDetailKey.all, 'mdm', id] as const,
  files: (id: string) => [...deviceDetailKey.all, 'files', id] as const,
  lifecycle: (id: string) => [...deviceDetailKey.all, 'lifecycle', id] as const,
  status: (id: string) => [...deviceDetailKey.all, 'status', id] as const,
} as const;
